import { ArdoqIcon, ArdoqIconCategory, IconSize } from '@ardoq/icons';
import { colors, fontWeight, space } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';
import { typographyMixins } from '@ardoq/typography';
import { TextOverflow } from '@ardoq/popovers';
import { EntityIcon } from './EntityIcon';

export type ComponentDecoratorAsTagProps = {
  shadedColor: string;
  lightenedColor: string;
  contrastColor: string;
  icon: ArdoqIcon;
  value: string;
  isImage: boolean;
  label: string;
  isSelected?: boolean;
  noMargin?: boolean;
};

export const ComponentDecoratorAsTag = ({
  shadedColor,
  lightenedColor,
  contrastColor,
  icon,
  value,
  isImage,
  label,
  isSelected = false,
  noMargin = false,
}: ComponentDecoratorAsTagProps) => {
  return (
    <ComponentTypeContainer
      $borderColor={shadedColor}
      $backgroundColor={lightenedColor}
      $isSelected={isSelected}
      $noMargin={noMargin}
    >
      <EntityIcon
        imageSrc={isImage ? value : undefined}
        iconId={
          icon.category === ArdoqIconCategory.FontAwesome || icon.isSVG
            ? icon.id
            : undefined
        }
        iconSize={IconSize.SMALL}
        color={contrastColor}
      />

      {label ? (
        <TextOverflow>
          <ComponentTypeLabel $color={contrastColor}>
            {label}
          </ComponentTypeLabel>
        </TextOverflow>
      ) : null}
    </ComponentTypeContainer>
  );
};

const selectedCSS = css`
  box-shadow:
    0 0 0 2px white,
    0 0 0 4px ${colors.borderFocus};
`;

export const ComponentTypeLabel = styled.span<{ $color: string }>`
  ${typographyMixins.caption}
  font-weight: ${fontWeight.semibold};
  color: ${props => props.$color};
`;

export type ComponentTagContainerProps = {
  $borderColor: string;
  $backgroundColor: string;
  $isSelected: boolean;
  $noMargin: boolean;
};

export const componentTagContainerCSS = css<ComponentTagContainerProps>`
  align-items: center;
  background-color: ${props => props.$backgroundColor};
  border-radius: 6px;
  border: 1px solid ${props => props.$borderColor};
  display: flex;
  max-width: 100%;
  width: fit-content;
  flex-direction: row;
  gap: ${space.xxsmall};
  padding: 1px 6px 1px ${space.xsmall};
  margin: ${props => (props.$noMargin ? '0' : `${space.xsmall} 0`)};
  ${props => (props.$isSelected ? selectedCSS : '')}
`;

export const ComponentTypeContainer = styled.div<ComponentTagContainerProps>`
  ${componentTagContainerCSS}
`;
